<mat-toolbar class="custom-header">
  <span (click)="guiService.goTo('main/home')">
    <mat-icon svgIcon="mat:arrow_back"></mat-icon>
  </span>
</mat-toolbar>
<div class="container">
  <h2>{{"STREAMING.TITLE" | translate}}</h2>
  <p>{{"STREAMING.UPCOMING" | translate}}</p>
  <span *ngIf="events && events.length > 0">
    <div class="event" *ngFor="let item of events">
      <img class="top-img" [src]="'../../../assets/img/streamingThumbs/'+item.category+'.png'">
      <span class="top-infos-streaming">
        <h2>{{item.i18nTitle[translate.currentLang.toUpperCase()]}}</h2>
        <p>{{item.i18nDescription[translate.currentLang.toUpperCase()]}}</p>
      </span>
      <div class="event-info">
        <div class="time-event-tutorial">
        <div class="time-event">
          <mat-icon svgIcon="mat:calendar_month"></mat-icon>
          <p>
            {{item.dateFormatted}}
          </p>
        </div>
        <div class="time-event">
          <mat-icon svgIcon="mat:av_timer"></mat-icon>
          <p>
            {{item.hourFrom}} - {{item.hourTo}}
          </p>
        </div>
      </div>
        <button class="its-button book-streaming" *ngIf="item.acceptation.length < 1" (click)="reservateEvent(item._id)">
          <span *ngIf="bookingSpinner.eventId !== item._id">{{"STREAMING.BOOK-BTN" | translate}}</span>
          <ion-spinner name="circular" *ngIf="bookingSpinner.spinner && bookingSpinner.eventId === item._id"
            style="height: 14px;"></ion-spinner>
        </button>
        <button class="its-button"
          *ngIf="item.acceptation.length > 0 && item.acceptation[0].userId === guiService.userLogged.user.id"
          disabled>{{"STREAMING.BOOKED" | translate}}</button>
      </div>
    </div>
  </span>

  <p *ngIf="events && events.length < 1" class="no-content">{{"STREAMING.NO-UPCOMING" | translate}}</p>

  <span *ngIf="!events">
    <div class="event skeleton" style="height: 421px;"></div>
  </span>
</div>
